import { typographyStyles } from "@newsela/angelou";
const { textMObj } = typographyStyles;

export const standardsCss = {
  margin: "0px 4px",
  ...textMObj,
};
